import { accumulationDistribution } from "@/lib/indicators/accumulation-distribution";
import { activityDetector } from "@/lib/indicators/activity-detector";
import { activityDetectorHighlighter } from "@/lib/indicators/activity-detector-highlighter";
import { alpha } from "@/lib/indicators/alpha";
import { altMeter } from "@/lib/indicators/alt-meter";
import { altucherBollingerBands } from "@/lib/indicators/altucher-bollinger-bands";
import { augmentedDickeyFullerTest } from "@/lib/indicators/augmented-dickey-fuller-test";
import { averageDayTradeSpeed } from "@/lib/indicators/average-day-trade-speed";
import { averageDayTradeVolume } from "@/lib/indicators/average-day-trade-volume";
import { averageTradesSize } from "@/lib/indicators/average-trade-size";
import { bestAskAndBidSize } from "@/lib/indicators/best-ask-and-bid-size";
import { beta } from "@/lib/indicators/beta";
import { bidAskDelta } from "@/lib/indicators/bid-ask-delta";
import { bidAskDeltaHighlighter } from "@/lib/indicators/bid-ask-delta-highlighter";
import { bollingerBands } from "@/lib/indicators/bollinger-bands";
import { commonActiveReturnMeasure } from "@/lib/indicators/common-active-return-measure";
import { cryptoDrift } from "@/lib/indicators/crypto-drift";
import { cumulativeLiquidationsDelta } from "@/lib/indicators/cumulative-liquidations-delta";
import { cumulativeStopKillerDelta } from "@/lib/indicators/cumulative-stop-killer-delta";
import { cumulativeVolumeDelta } from "@/lib/indicators/cumulative-volume-delta";
import { dayHighAndLow } from "@/lib/indicators/day-high-and-low";
import { depthOfMarket } from "@/lib/indicators/depth-of-market";
import { garchVolatilityEstimation } from "@/lib/indicators/garch-volatility-estimation";
import { hftActivity } from "@/lib/indicators/hft-activity";
import { hullWhiteVolatilityModel } from "@/lib/indicators/hull-white-volatility-model";
import { ideas } from "@/lib/indicators/ideas";
import { keltnerChannel } from "@/lib/indicators/keltner-channel";
import { layeringHighlighter } from "@/lib/indicators/layering-highlighter";
import { liquidations } from "@/lib/indicators/liquidations";
import { liquidationsHighlighter } from "@/lib/indicators/liquidations-highlighter";
import { strategies } from "@/lib/indicators/strategies";
import { localVolalility } from "@/lib/indicators/local-volalility";
import { manipulationMonitor } from "@/lib/indicators/manipulation-monitor";
import { manipulationMonitorHighlighter } from "@/lib/indicators/manipulation-monitor-highlighter";
import { marketFacilitationIndex } from "@/lib/indicators/market-facilitation-index";
import { marketPower } from "@/lib/indicators/market-power";
import { marketPowerHighlighter } from "@/lib/indicators/market-power-highlighter";
import { marketRatio } from "@/lib/indicators/market-ratio";
import { moneyFlowIndex } from "@/lib/indicators/money-flow-index";
import { movingAverage } from "@/lib/indicators/moving-average";
import { natrVolalility } from "@/lib/indicators/natr-volalility";
import { netOpenInterest } from "@/lib/indicators/net-open-interest";
import { netOpenInterestDelta } from "@/lib/indicators/net-open-interest-delta";
import { netOpenInterestSpike } from "@/lib/indicators/net-open-interest-spike";
import { normalizedMomentumIndicator } from "@/lib/indicators/normalized-momentum-indicator";
import { openInterest } from "@/lib/indicators/open-interest";
import { openInterestDelta } from "@/lib/indicators/open-interest-delta";
import { openInterestSpike } from "@/lib/indicators/open-interest-spike";
import { orderFlowIntesity } from "@/lib/indicators/order-flow-intesity";
import { percentagePriceOscillator } from "@/lib/indicators/percentage-price-oscillator";
import { positiveNegativeDataIndex } from "@/lib/indicators/positive-negative-data-index";
import { powerTrades } from "@/lib/indicators/power-trades";
import { powerVolumeDelta } from "@/lib/indicators/power-volume-delta";
import { pumpTrend } from "@/lib/indicators/pump-trend";
import { pumpTrendHighlighter } from "@/lib/indicators/pump-trend-highlighter";
import { quotedSpread } from "@/lib/indicators/quoted-spread";
import { rateOfChange } from "@/lib/indicators/rate-of-change";
import { realizedVolalility } from "@/lib/indicators/realized-volalility";
import { retailPower } from "@/lib/indicators/retail-power";
import { retailPowerHighlighter } from "@/lib/indicators/retail-power-highlighter";
import { rollingVwap } from "@/lib/indicators/rolling-vwap";
import { rsiCannel } from "@/lib/indicators/rsi-channel";
import { rtIndex } from "@/lib/indicators/rt-index";
import { sharpeRatio } from "@/lib/indicators/sharpe-ratio";
import { simpleCevVolatilityApproximation } from "@/lib/indicators/simple-cev-volatility-approximation";
import { skewVolatility } from "@/lib/indicators/skew-volatility";
import { spoofingHighlighter } from "@/lib/indicators/spoofing-highlighter";
import { spotPerpetualsAugmentedDickeyFullerTest } from "@/lib/indicators/spot-perpetuals-augmented-dickey-fuller-test";
import { spotPerpetualsDominance } from "@/lib/indicators/spot-perpetuals-dominance";
import { spotPerpetualsDominanceHighlighter } from "@/lib/indicators/spot-perpetuals-dominance-highlighter";
import { spotPerpetualsFundingRate } from "@/lib/indicators/spot-perpetuals-funding-rate";
import { spotPerpetualsSpread } from "@/lib/indicators/spot-perpetuals-spread";
import { spotPerpetualsTimeDominance } from "@/lib/indicators/spot-perpetuals-time-dominance";
import { spotPerpetualsWho } from "@/lib/indicators/spot-perpetuals-who";
import { standardizedActiveReturnMeasure } from "@/lib/indicators/standardized-active-return-measure";
import { stopKiller } from "@/lib/indicators/stop-killer";
import { stopKillerHighlighter } from "@/lib/indicators/stop-killer-highlighter";
import { takeProfitAndStopLoss } from "@/lib/indicators/take-profit-and-stop-loss";
import { tape } from "@/lib/indicators/tape";
import { tickIndex } from "@/lib/indicators/tick-index";
import { tradingSessionsHighlighter } from "@/lib/indicators/trading-sessions-highlighter";
import { trendAssessment } from "@/lib/indicators/trend-assessment";
import { valueAtRisk } from "@/lib/indicators/value-at-risk";
import { volatillity } from "@/lib/indicators/volatillity";
import { volumeDelta } from "@/lib/indicators/volume-delta";
import { volumePriceTrend } from "@/lib/indicators/volume-price-trend";
import { zScore } from "@/lib/indicators/z-score";
import { PineJS } from "@tradingView/charting_library";
import { EBillingPlan } from "@/domain/interfaces/marketplace.interface.ts";

export function getSFIndicators(
  PineJS: PineJS,
  productIds: string[] = [],
  userRole: string,
) {
  return [
    accumulationDistribution(PineJS, {
      category: "Technical",
      productId: "zaRxOahIEtmHkgLGPqd2-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    activityDetector(PineJS, {
      category: "Technical",
      productId: "y27vs4UojwKTUdzFAm2U",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.PRO,
      packages: ["gSu7mYLXllxTYfWhGPMF"],
    }),
    activityDetectorHighlighter(PineJS, {
      category: "Market Structure",
      productId: "y27vs4UojwKTUdzFAm2U",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.PRO,
      packages: ["gSu7mYLXllxTYfWhGPMF"],
    }),
    alpha(PineJS),
    altMeter(PineJS, {
      category: "Microstructure",
      productId: "0MsqRnltFGn53Y8TKiy4",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    altucherBollingerBands(PineJS),
    skewVolatility(PineJS, {
      category: "Quantitative Analysis",
      productId: "free",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.BASIC,
    }),
    augmentedDickeyFullerTest(PineJS, {
      category: "Quantitative Analysis",
      productId: "SIUFFaOBsOCdGDoIs44j",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY"],
    }),
    averageDayTradeSpeed(PineJS, {
      category: "Microstructure",
      productId: "1huwm7r7oYKVSC13PmiS",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["gSu7mYLXllxTYfWhGPMF"],
    }),
    averageDayTradeVolume(PineJS, {
      category: "Microstructure",
      productId: "1huwm7r7oYKVSC13PmiS",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["gSu7mYLXllxTYfWhGPMF"],
    }),
    averageTradesSize(PineJS),
    bestAskAndBidSize(PineJS),
    beta(PineJS),
    bidAskDelta(PineJS, {
      category: "Microstructure",
      productId: "8WsFMJuRWLMXFaPQu8pV-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["mvuRebngQzG296aE9Szg"],
    }),
    bidAskDeltaHighlighter(PineJS, {
      category: "Microstructure",
      productId: "8WsFMJuRWLMXFaPQu8pV",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    bollingerBands(PineJS, {
      category: "Technical",
      productId: "1CZ92lqtYBiYCCo4RZiv-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["mvuRebngQzG296aE9Szg", "xSL4BDy3i6vQKnjfv1x1"],
    }),
    commonActiveReturnMeasure(PineJS),
    cryptoDrift(PineJS, {
      category: "Market Structure",
      productId: "aJhDxmtqStNiRpHQ0Ml9",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY"],
    }),
    cumulativeLiquidationsDelta(PineJS),
    cumulativeStopKillerDelta(PineJS, {
      category: "Microstructure",
      productId: "KwBuJt40FO2A8Qu65Du4",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["96HDpuXerrLxZP02zqno"],
    }),
    cumulativeVolumeDelta(PineJS),
    dayHighAndLow(PineJS),
    depthOfMarket(PineJS),
    garchVolatilityEstimation(PineJS),
    hftActivity(PineJS, {
      category: "Microstructure",
      productId: "VxnVAanewBUAGx4n7Csp",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: [
        "gSu7mYLXllxTYfWhGPMF",
        "mvuRebngQzG296aE9Szg",
        "xSL4BDy3i6vQKnjfv1x1",
      ],
    }),
    hullWhiteVolatilityModel(PineJS),
    ideas(PineJS, {
      category: "Microstructure",
      productId: "eWl80SXNw7MGIjixYzTd",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.PRO,
    }),
    keltnerChannel(PineJS, {
      category: "Technical",
      productId: "IPFRrU8ZgzJjDlUqvCFW-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    layeringHighlighter(PineJS, {
      category: "Microstructure",
      productId: "cq7gVOHjVzqOe6cmF0Os-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.PRO,
      packages: ["gSu7mYLXllxTYfWhGPMF"],
    }),
    liquidations(PineJS),
    liquidationsHighlighter(PineJS),
    strategies(PineJS, {
      category: "Microstructure",
      productId: "XqLUuiL7rtO8qANDyO1Z-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["gSu7mYLXllxTYfWhGPMF", "5tmWZZy2uEJ7z3iTNCON"],
    }),
    localVolalility(PineJS),
    manipulationMonitor(PineJS, {
      category: "Microstructure",
      productId: "qJOaXlQyplBF93CZ4DI4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["gSu7mYLXllxTYfWhGPMF", "xSL4BDy3i6vQKnjfv1x1"],
    }),
    manipulationMonitorHighlighter(PineJS, {
      category: "Microstructure",
      productId: "qJOaXlQyplBF93CZ4DI4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["gSu7mYLXllxTYfWhGPMF", "xSL4BDy3i6vQKnjfv1x1"],
    }),
    marketFacilitationIndex(PineJS, {
      category: "Technical",
      productId: "37N68ZDHpiB9sozZmZN4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    marketPower(PineJS, {
      category: "Microstructure",
      productId: "67esE9N7HuC84bRw00rj",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.EXPERT,
    }),
    marketPowerHighlighter(PineJS, {
      category: "Microstructure",
      productId: "67esE9N7HuC84bRw00rj",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.EXPERT,
    }),
    marketRatio(PineJS, {
      category: "Market Overview",
      productId: "QjGQnUg6RPrW0YqR4vOT-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["mvuRebngQzG296aE9Szg"],
    }),
    moneyFlowIndex(PineJS, {
      category: "Technical",
      productId: "kIW36BS4S5XXd15uyRr3-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    movingAverage(PineJS, {
      category: "Technical",
      productId: "AVjdvZsEkrnbnZzpJJq3-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    natrVolalility(PineJS),
    netOpenInterest(PineJS, {
      category: "Microstructure",
      productId: "sOL1XuOSNGyTxeMhvuly-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: [
        "96HDpuXerrLxZP02zqno",
        "mvuRebngQzG296aE9Szg",
        "xSL4BDy3i6vQKnjfv1x1",
      ],
    }),
    netOpenInterestDelta(PineJS, {
      category: "Microstructure",
      productId: "sOL1XuOSNGyTxeMhvuly-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: [
        "96HDpuXerrLxZP02zqno",
        "mvuRebngQzG296aE9Szg",
        "xSL4BDy3i6vQKnjfv1x1",
      ],
    }),
    netOpenInterestSpike(PineJS, {
      category: "Microstructure",
      productId: "sOL1XuOSNGyTxeMhvuly-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: [
        "96HDpuXerrLxZP02zqno",
        "mvuRebngQzG296aE9Szg",
        "xSL4BDy3i6vQKnjfv1x1",
      ],
    }),
    normalizedMomentumIndicator(PineJS),
    openInterest(PineJS),
    openInterestDelta(PineJS),
    openInterestSpike(PineJS),
    orderFlowIntesity(PineJS, {
      category: "Microstructure",
      productId: "JlibGoBJaUYDbXOqjclI-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["mvuRebngQzG296aE9Szg"],
    }),
    rollingVwap(PineJS, {
      category: "Technical",
      productId: "1CZ92lqtYBiYCCo4RZiv-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["mvuRebngQzG296aE9Szg"],
    }),
    percentagePriceOscillator(PineJS),
    positiveNegativeDataIndex(PineJS, {
      category: "Technical",
      productId: "vLtjJo7dYE9cqchRhU2j-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    powerTrades(PineJS, {
      category: "Microstructure",
      productId: "8SayUUN0V5bzeoGGlfVO-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: [
        "gSu7mYLXllxTYfWhGPMF",
        "mvuRebngQzG296aE9Szg",
        "xSL4BDy3i6vQKnjfv1x1",
      ],
    }),
    powerVolumeDelta(PineJS, {
      category: "Microstructure",
      productId: "jjjs6gSCjzwIi2noMwFr-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    pumpTrend(PineJS, {
      category: "Microstructure",
      productId: "JpJppWj1u0vwUQtlJE47-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.EXPERT,
    }),
    pumpTrendHighlighter(PineJS),
    quotedSpread(PineJS),
    rateOfChange(PineJS, {
      category: "Technical",
      productId: "VDCV72DvONAflSfNBFl7-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    realizedVolalility(PineJS),
    retailPower(PineJS, {
      category: "Microstructure",
      productId: "4QcYbA0fRlQRgu7TVG2v-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.EXPERT,
    }),
    retailPowerHighlighter(PineJS, {
      category: "Microstructure",
      productId: "4QcYbA0fRlQRgu7TVG2v-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.EXPERT,
    }),
    rsiCannel(PineJS, {
      category: "Technical",
      productId: "1CZ92lqtYBiYCCo4RZiv-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["mvuRebngQzG296aE9Szg"],
    }),
    rtIndex(PineJS, {
      category: "Microstructure",
      productId: "0MsqRnltFGn53Y8TKiy4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    sharpeRatio(PineJS),
    simpleCevVolatilityApproximation(PineJS),
    spoofingHighlighter(PineJS, {
      category: "Microstructure",
      productId: "P1opn2c33Ot3aqv4kpZd-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY", "gSu7mYLXllxTYfWhGPMF"],
    }),
    spotPerpetualsAugmentedDickeyFullerTest(PineJS, {
      category: "Microstructure",
      productId: "tKbRaL4kCF1PQyM2DuB7-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY", "gSu7mYLXllxTYfWhGPMF"],
    }),
    spotPerpetualsDominance(PineJS, {
      category: "Microstructure",
      productId: "tKbRaL4kCF1PQyM2DuB7-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY", "gSu7mYLXllxTYfWhGPMF"],
    }),
    spotPerpetualsDominanceHighlighter(PineJS, {
      category: "Microstructure",
      productId: "tKbRaL4kCF1PQyM2DuB7-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY", "gSu7mYLXllxTYfWhGPMF"],
    }),
    spotPerpetualsFundingRate(PineJS),
    spotPerpetualsSpread(PineJS),
    spotPerpetualsTimeDominance(PineJS, {
      category: "Microstructure",
      productId: "zacKxXzOh15yJM26VZNz-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["C6g8M1XFSgTdXQHmhyDY", "gSu7mYLXllxTYfWhGPMF"],
    }),
    spotPerpetualsWho(PineJS, {
      category: "Microstructure",
      productId: "tKbRaL4kCF1PQyM2DuB7-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    standardizedActiveReturnMeasure(PineJS),
    stopKiller(PineJS, {
      category: "Microstructure",
      productId: "KwBuJt40FO2A8Qu65Du4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["96HDpuXerrLxZP02zqno", "mvuRebngQzG296aE9Szg"],
    }),
    stopKillerHighlighter(PineJS, {
      category: "Microstructure",
      productId: "KwBuJt40FO2A8Qu65Du4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
      packages: ["96HDpuXerrLxZP02zqno", "mvuRebngQzG296aE9Szg"],
    }),
    takeProfitAndStopLoss(PineJS),
    tape(PineJS),
    tickIndex(PineJS, {
      category: "Microstructure",
      productId: "0MsqRnltFGn53Y8TKiy4-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    tradingSessionsHighlighter(PineJS),
    trendAssessment(PineJS, {
      category: "Technical",
      productId: "bPhzbnd0GmvhE02nEqrO-indicator",
      purchasedProductIds: productIds,
      userRole: userRole,
      plan: EBillingPlan.TRADER,
    }),
    valueAtRisk(PineJS),
    volatillity(PineJS),
    volumeDelta(PineJS),
    volumePriceTrend(PineJS),
    // volumeTradingWashCleared(PineJS, {
    //   category: "Microstructure",
    //   productId: "KwBuJt40FO2A8Qu65Du4-indicator",
    //   purchasedProductIds: productIds,
    //   userRole: userRole,
    //   plan: EBillingPlan.TRADER,
    // }),
    zScore(PineJS),
  ];
}
